import { MultiSelect, NumberInput } from 'corso-admin-ui';
import { isTruthy } from 'corso-types';
import { Controller } from 'react-hook-form';
import { useAutomationFormContext } from '~/features/settings/automations/hooks/useAutomationForm';
import useFulfillmentLocations from '~/features/settings/automations/hooks/useFulfillmentLocations';
import { getNullableNumberValue } from '~/utils/form';

export function EventShippingClaimReorderLocations() {
  const { control } = useAutomationFormContext();

  const locations = useFulfillmentLocations();

  const locationOptions =
    locations.data?.map((location) => ({
      value: `${location.id}`,
      label: location.name,
    })) ?? [];

  return (
    <>
      <Controller
        control={control}
        name="event.params.reorderLocationIds"
        render={({ field, fieldState }) => (
          <MultiSelect
            label="Allowed Reorder Locations"
            details="The fulfillment locations a reorder can be sourced from."
            placeholder="Select Fulfillment Locations"
            options={locationOptions}
            value={field.value
              .map((id) =>
                locationOptions.find((option) => option.value === `${id}`),
              )
              .filter(isTruthy)}
            onChange={(selections) =>
              field.onChange(
                selections.map((selection) =>
                  Number.parseInt(selection.value, 10),
                ),
              )
            }
            error={fieldState.error?.message}
          />
        )}
      />
      <Controller
        control={control}
        name="event.params.minInventoryAvailable"
        render={({ field: { value, onChange }, fieldState }) => (
          <NumberInput
            id="min-inventory-available"
            label="Minimum Inventory Available"
            details="Locations with less inventory than this are treated as out of stock. Defaults to 1."
            error={fieldState.error?.message}
            value={value}
            onChange={(e) => onChange(getNullableNumberValue(e))}
          />
        )}
      />
    </>
  );
}
